import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router';

import PaidSearchActivityTableContainer from '@/app/paid-search/PaidSearchActivityTableContainer';
import PaidSearchFitScoringTable from '@/app/paid-search/PaidSearchFitScoringTable';
import PaidSearchOverviewKPIMetrics from '@/app/paid-search/PaidSearchOverviewKPIMetrics';
import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';

const DEFAULT_SORT = {
  sortBy: 'visits',
  sortOrder: InstantSearchSortOrder.DESC,
};

const DEFAULT_QUERY_STATE: Partial<QueryState> = {
  size: 20,
  ...DEFAULT_SORT,
};

const PaidSearchOverviewContent = () => {
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get('type');
  const breakdownType = useMemo<'adGroup' | 'keyword'>(
    () => (typeParam === 'keyword' ? 'keyword' : 'adGroup'),
    [typeParam],
  );
  const [scoreAdGroupIds, setScoreAdGroupIds] = useState<string[]>([]);
  const [scoreKeywordIds, setScoreKeywordIds] = useState<string[]>([]);

  return (
    <InstantSearch prefix="p" defaultQueryState={DEFAULT_QUERY_STATE}>
      <PaidSearchOverviewKPIMetrics />
      <PaidSearchActivityTableContainer
        defaultSort={DEFAULT_SORT}
        breakdownType={breakdownType}
        onScoreAdGroups={setScoreAdGroupIds}
        onScoreKeywords={setScoreKeywordIds}
      />
      <PaidSearchFitScoringTable
        breakdownType={breakdownType}
        adGroupIds={scoreAdGroupIds}
        keywordIds={scoreKeywordIds}
      />
    </InstantSearch>
  );
};

export default PaidSearchOverviewContent;
